import CoverageBenefits from './CoverageBenefits'
export default CoverageBenefits
